import { TopicListItem } from '@all-manager/design-system-v2';
import type { TopicDatabase } from '../../../../types';
import { formatActiveSubTopicCount, type TopicListPage } from '../../pages/useTopicListPage';
import TopicMenuAction from '../TopicMenuAction/TopicMenuAction';

type Props = {
  page: TopicListPage;
  topic: TopicDatabase;
};

export default function TopicRow(props: Props) {
  const page = props.page;

  return (
    <TopicListItem
      name={props.topic.name}
      href={page.getTopicHref(props.topic.id)}
      onClick={page.getTopicClickHandler(props.topic.id)}
      description={formatActiveSubTopicCount(page.activeCountByTopic[props.topic.id] ?? 0)}
      selected={props.topic.id === page.topicId}
      archived={Boolean(props.topic.archived)}
      action={page.isAdmin ? (
        <TopicMenuAction topic={props.topic} onDeleted={page.handleTopicDeleted} />
      ) : undefined}
    />
  );
}
